import getAjaxUrl from '../../steps/route/ajax-url.js';
const eventTrackingURl = 'ajax/userevent/';

export default class EventTracking {
  constructor() {
    const clickEvents = document.querySelectorAll('[data-event-click]');
    const playEvents = document.querySelectorAll('[data-event-play]');

    clickEvents.forEach(element => {
      element.addEventListener('click', this.onClick, { passive: true });
    });

    playEvents.forEach(element => {
      element.addEventListener('click', this.onPlay, { passive: true });
    });
  }

  onClick(event) {
    const element = event.target;

    if (element.dataset.eventClick == undefined) {
      return;
    }

    let type = 'click';
    if (element.dataset.eventType !== undefined) {
      type = element.dataset.eventType;
    }

    let details = '';
    if(element.dataset.eventDetails !== undefined) {
      details = element.dataset.eventDetails;
    }

    EventTracking.submitEvent(
      new UserEvent(element.dataset.eventClick, type, document.location.pathname, details),
      false,
      element.dataset?.eventQueue
    );
  }

  onPlay(event) {
    const element = event.target;

    if (element.dataset.eventPlay == undefined) {
      return;
    }

    let details = {};
    if(element.dataset.eventDetails !== undefined) {
      details = element.dataset.eventDetails;
    }

    EventTracking.submitEvent(
      new UserEvent(element.dataset.eventPlay, 'play', document.location.pathname, details),
      false,
      element.dataset?.eventQueue
    );
  }

  static submitEvent(event, callback, forceQueue = false) {
    try {
      const xhr = new XMLHttpRequest();
      const formData = new FormData();
      xhr.open('POST', getAjaxUrl(eventTrackingURl));
      formData.append('event', JSON.stringify(event));
      if (forceQueue) formData.append('queue', true);
      xhr.onload = () => {
        if (xhr.status !== 200) {
          console.error('Error during submission of event: non 200 response code');
        }
        if (callback) {
          callback();
        }
      };

      xhr.onerror = () => {
        console.error('Error during submission of event: xhr error');
      };

      xhr.send(formData);
    } catch (e) {
      console.error('Error during submission of event: ' + e);
    }
  }
}

class UserEvent {
  constructor(identifier, type, path, details='') {
    this.identifier = identifier;
    this.type = type;
    this.path = path;
    this.details = details;
  }
}

export { EventTracking, UserEvent };
